export default __webpack_public_path__ + "static/media/dr-rashmi-new.749eb895.jpg";